import React from "react";

const SakuraSeparator = () => {
  return (
    <div className="separator-sakura">
      <div className="separator-sakura-icon"></div>
    </div>
  );
};

export default SakuraSeparator;
